import { TestimonialCardData } from '../types';

// Testimonials Data
export const TESTIMONIALS_DATA: TestimonialCardData[] = [
  {
    title:
      "Over <span class='text-blue-350'>5 million</span> tax payers have filed with us",
    description:
      "I have been using ClearTax's DIY e-filing of ITR for last 3 years. I use it for my entire family's income tax returns. Very effective <br class='lg:hidden md:hidden sm:hidden'/> and least time consuming. <br> <br> <br class='xl:hidden lg:hidden md:hidden'/>",
    image1:
      'https://assets1.cleartax-cdn.com/cleartax/images/1606110840_mrmanmohan1.png',
    image1Alt: 'client1',
    customer: 'Mr. Manmohan',
    location: 'Tax Payer, Kochi, Kerala',
    link: 'you',
    fold: 'Individuals',
    message:
      "File ITRs yourself or seek expert assistance<span class='font-medium'>&nbsp; →</span>",
    image2:
      'https://assets1.cleartax-cdn.com/cleartax/images/1606367863_indiviual_testimonial.png',
    image2Alt: 'indiviual_testimonial',
  },
  {
    title:
      "More than <span class='text-blue-350'>60,000</span> tax experts use our platform",
    description:
      "My executives could learn it so quickly and we implemented literally in a couple of days. I am impressed with time-saving features embedded in the software like advanced reconciliation of 2A data with invoices. <br class='xl:hidden lg:hidden md:hidden'/>",
    image1:
      'https://assets1.cleartax-cdn.com/cleartax/images/1602838327_carouselanilchakravarthy.png',
    image1Alt: 'client',
    customer: 'Mr. Anil Chakravarthy',
    location: 'Tax Suite user',
    link: 'tax-experts',
    fold: 'Tax Experts',
    message:
      "Explore products for tax experts<span class='font-medium'>&nbsp; →</span>",
    image2:
      'https://assets1.cleartax-cdn.com/cleartax/images/1606367875_smb_testimonial.png',
    image2Alt: 'smb_testimonial',
  },
  {
    title:
      "<span class='text-blue-350'>600,000+</span> businesses trust our SMB offerings",
    description:
      "Earlier I used to call multiple customers, track my bank account or check messages for payments. Now I can send UPI links in reminders and customers can pay from home. Compliance is easy. <br class='xl:hidden lg:hidden md:hidden'/> <br class='xl:hidden lg:hidden md:hidden'/>",
    image1:
      'https://assets1.cleartax-cdn.com/cleartax/images/1605861410_shalini_prasad1.png',
    image1Alt: 'client',
    customer: 'Shalini Prasad',
    location: 'Business Owner, Printing Goods',
    link: 'sme',
    fold: 'sme',
    message:
      "Explore products for Small Businesses <span class='font-medium'>&nbsp; →</span>",
    image2:
      'https://assets1.cleartax-cdn.com/cleartax/images/1606367991_enterprise_testimonial.png',
    image2Alt: 'enterprise_testimonial',
  },
  {
    title:
      "Over <span class='text-blue-350'>1,200</span> enterprises use our compliance stack",
    description:
      "ClearTax has made core GST returns simple and easy for us. Instead of taking 7 to 8 days to do reconciliation, now it's just a matter of hours. The people there assist us at any given point in time. <br class='xl:hidden lg:hidden md:hidden'/> <br class='xl:hidden lg:hidden md:hidden'/>",
    image1:
      'https://assets1.cleartax-cdn.com/cleartax/images/1605862455_manivanan_p.png',
    image1Alt: 'client',
    customer: 'Manivannan P',
    location: 'Group Manager, Titan',
    link: 'enterprise',
    fold: 'enterprise',
    message:
      "Explore our products for Large Enterprises <span class='font-medium'>&nbsp; →</span>",
    image2:
      'https://assets1.cleartax-cdn.com/cleartax/images/1606367999_ca_testimonial.png',
    image2Alt: 'ca_testimonial',
  },
];
